import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import CyberSecureModData from '../data/CyberSecureModData'
import CounterArea from '../components/CounterArea'
import Enroll from '../components/Enroll'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickCyberData } from '../data/SlickSliderData'
import { CounterData2 } from '../data/CounterData'
import { EnrollData } from '../data/EnrollData'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function CyberSecurityBitcoinModules() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickCyberData} />
            <FundamentalCourses2 data={CyberSecureModData} />
            <CounterArea data={CounterData2} />
            <Enroll data={EnrollData} />
            <RelatedCourses />
            <Footer />
        </>
    )
}
